<script>
	import { getContext } from 'svelte'
	import { fade } from 'svelte/transition'
	import { storeShowGallery, storeExpand } from '../library/scripts/Store.svelte'
	import * as animateScroll from 'svelte-scrollto'
	import { styles } from '../library/scripts/styles'

	export let color = 'hsla(200,70%,50%,1)'
	export let colorHover = 'hsla(200,70%,60%,1)'

	const globals = getContext('globals')
	const caretLarge = globals.caretLarge

	let scrollY
	let visible = false
	let portrait = false

	$: if (window.innerHeight > window.innerWidth) portrait = true
	$: if (window.innerHeight < window.innerWidth) portrait = false

	$: if (scrollY > 10 && !portrait) {
		visible = true
	}

	$: if (scrollY < 10 && !portrait) {
		visible = false
	}

	$: if (portrait) {
		visible = true
	}

	const win_resize = () => {
		if (window.innerHeight > window.innerWidth) {
			portrait = true
		} else {
			portrait = false
		}
	}

	const scroll_top = () => {
		animateScroll.scrollToTop()
		storeShowGallery.set(false)
		storeExpand.set(false)
	}
</script>

<svelte:window bind:scrollY on:resize={win_resize} />
{#if visible}
	<div
		transition:fade={{ duration: 500 }}
		class="scrolltop"
		use:styles={{ caretLarge, color, colorHover }}
		on:click={scroll_top}
		on:keydown={scroll_top}
	/>
{/if}

<style>
	.scrolltop {
		position: fixed;
		display: block;
		cursor: pointer;
		z-index: 5;
		min-width: var(--caretLarge);
		min-height: var(--caretLarge);
		top: calc(98vh - var(--caretLarge));
		left: calc(90vw - var(--caretLarge));
		background-color: transparent;
		border-left: var(--caretLarge) solid transparent;
		border-right: var(--caretLarge) solid transparent;
		border-bottom: var(--caretLarge) solid var(--color);
	}

	.scrolltop:hover {
		border-bottom: var(--caretLarge) solid var(--colorHover);
	}
</style>
